import en from './en/common';
import fr from './fr/common';

export const resources = {
  en: {
    translation: en,
  },
  fr: {
    translation: fr,
  },
};